import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _noop from 'lodash/noop';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Close from 'yoda-core-components/lib/assets/svg/Close.svg';
import IconArrowLeftBlack from 'yoda-core-components/lib/assets/svg/IconArrowLeftBlack.svg';
import HambCloseApollo from 'yoda-core-components/lib/assets/svg/HambCloseApollo.svg';
import IconArrowLeftApollo from 'yoda-core-components/lib/assets/svg/IconArrowLeftApollo.svg';
import ScrollLockHOCFactory from 'yoda-core-components/lib/hoc/ScrollLockHOC/ScrollLockHOC';
import classNames from 'classnames/bind';
import _get from 'lodash/get';
import { enableFeatureInApp } from '../../helpers/Utils/features';
import * as nativeAppActions from '../../actions/NativeAppAction';
import * as ATCInterstitalActions from '../../actions/ATCInterstitalAction';
import SlidePanelContext from './SlidePanelContext';
import { atcHeaderOptions } from '../../common/Constants';
import * as styles from './SlidePanel.css';

const cx = classNames.bind(styles);

export class SlidePanel extends Component {
    static propTypes = {
        isOpenPanel: PropTypes.bool,
        onClosePanel: PropTypes.func.isRequired,
        onBackPanel: PropTypes.func, // updated this to handle this console warning Failed prop type: The prop `onBackPanel` is marked as required in `SlidePanel`, but its value is `undefined`.
        onCloseTransitionEnd: PropTypes.func,
        onOpenTransitionEnd: PropTypes.func,
        panelTitle: PropTypes.string,
        children: PropTypes.element,
        panelIcon: PropTypes.string,
        deviceType: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
        panelTitleAlignment: PropTypes.oneOf(['default', 'right', 'justified']),
        hideContentScroll: PropTypes.bool,
        enableExpandedAtc: PropTypes.bool,
        backButton: PropTypes.bool,
        panelTitleClass: PropTypes.string,
        theme: PropTypes.string,
        panelHeaderRenderer: PropTypes.func,
        panelContentTheme: PropTypes.string,
        cartSuccess: PropTypes.bool,
        cartAdditionalServices: PropTypes.bool,
        panelIconComponent: PropTypes.func,
        actions: PropTypes.object,
        isNative: PropTypes.bool,
        requestUrl: PropTypes.string,
        nativeCustomPanelHeader: PropTypes.string,
        enableFullViewPanel: PropTypes.bool,
        fromKA: PropTypes.bool,
        mobileAppWebViewBuildConfig: PropTypes.object,
    };

    static defaultProps = {
        isOpenPanel: false,
        panelTitle: '',
        children: '',
        panelIcon: 'arrow-left-black',
        panelIconComponent: <IconArrowLeftBlack />,
        panelTitleAlignment: 'default',
        onCloseTransitionEnd: null,
        onOpenTransitionEnd: null,
        deviceType: {},
        hideContentScroll: false,
        enableExpandedAtc: false,
        backButton: false,
        panelTitleClass: '',
        theme: '',
        panelHeaderRenderer: null,
        panelContentTheme: '',
        cartSuccess: false,
        cartAdditionalServices: false,
        onBackPanel: _noop, // // updated this to handle this console warning Failed prop type: The prop `onBackPanel` is marked as required in `SlidePanel`, but its value is `undefined`.
        actions: {},
        isNative: false,
        requestUrl: '',
        nativeCustomPanelHeader: '',
        enableFullViewPanel: false,
        fromKA: false,
        mobileAppWebViewBuildConfig: {},
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.closePanel = this.closePanel.bind(this);
        this.backPanel = this.backPanel.bind(this);
        this.onCloseTransitionEnd = this.onCloseTransitionEnd.bind(this);
        this.onOpenTransitionEnd = this.onOpenTransitionEnd.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);
        this.state = {
            animateOnLoad: props.isOpenPanel,
            // This state represents if the panel was completely closed (after transition)
            closed: !props.isOpenPanel,
            showDetailSlider: false,
            detailSliderContent: '',
            couponDraw: false,
        };
    }

    componentDidMount() {
        if (!this.state.closed) {
            this.patchNativeHeader(false);
        }
        if (this.props.isNative) {
            document.removeEventListener('nativeAppBackPress', this.closePanel);
            document.addEventListener('nativeAppBackPress', this.closePanel);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isOpenPanel && !this.props.isOpenPanel) {
            this.setState({
                closed: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpenPanel !== this.props.isOpenPanel) {
            this.props.isOpenPanel ? this.patchNativeHeader(false) : this.patchNativeHeader(true);
        }
    }

    componentWillUnmount() {
        this.patchNativeHeader(true);
        if (this.props.isNative) {
            this.props.actions.ResetATCAddEdit();
            document.removeEventListener('nativeAppBackPress', this.closePanel);
        }
    }

    onOpenTransitionEnd() {
        if (typeof this.props.onOpenTransitionEnd === 'function') {
            this.props.onOpenTransitionEnd();
        }
        this.props.theme === 'couponDrawer' &&
            this.setState({
                couponDraw: false,
            });
    }

    onCloseTransitionEnd() {
        if (typeof this.props.onCloseTransitionEnd === 'function') {
            this.props.onCloseTransitionEnd();
        }
        this.props.theme === 'couponDrawer'
            ? this.setState({
                  closed: true,
                  couponDraw: true,
              })
            : this.setState({
                  closed: true,
              });
    }

    onTransitionEnd() {
        this.props.isOpenPanel ? this.onOpenTransitionEnd() : this.onCloseTransitionEnd();
    }

    getStyleToogleWrapper() {
        const toogleWrapper = this.props.isOpenPanel
            ? `${styles.toggleWrapper} ${styles.activeToggleWrapper}`
            : styles.toggleWrapper;
        return toogleWrapper;
    }

    getStyleTooglePanel() {
        const tooglePanel = this.props.isOpenPanel
            ? `${styles.detailsPanel} ${styles.activeDetailsPanel}`
            : this.state.couponDraw
            ? `${styles.detailsPanel} ${styles.animateOnClose}`
            : `${styles.detailsPanel}`;
        return tooglePanel;
    }

    closePanel(e) {
        const { isAddEditSlider: { isAddorEdit } = {}, isNative } = this.props;
        e.preventDefault();
        if (isNative && this.state.showDetailSlider && isAddorEdit) {
            this.setState({ showDetailSlider: false });
            this.backPanel(e);
        } else if (this.state.showDetailSlider) {
            this.setState({ showDetailSlider: false });
            this.props.onClosePanel(e);
        } else {
            this.props.onClosePanel(e);
        }
    }

    backPanel(e) {
        e.preventDefault();
        if (this.state.showDetailSlider) {
            this.setState({ showDetailSlider: false });
        } else {
            this.props.onBackPanel && this.props.onBackPanel(e);
        }
    }

    /* istanbul ignore next */
    showDetailSlider = (content) => {
        this.setState({ showDetailSlider: true, detailSliderContent: content });
    };

    getCartAtcHeaderText = () => {
        const { showDetailSlider } = this.state;
        const headerText = showDetailSlider
            ? atcHeaderOptions.DETAILS
            : atcHeaderOptions.ADDITIONAL_OPTIONS;
        return headerText;
    };

    cartATCPanelHeader = () => {
        let { backButton } = this.props;
        const { showDetailSlider } = this.state;
        if (showDetailSlider) {
            backButton = true;
        }
        return (
            <div className={cx(styles.panelHeader)}>
                <>
                    {backButton && (
                        <a
                            href="javascript:void(0)"
                            className={cx('backIcon', 'panelBackIcon')}
                            onClick={this.backPanel}
                            data-automation-id="at-slide-back-button"
                        >
                            <Icon
                                iconType="svg"
                                width="24px"
                                height="24px"
                                viewBox="0 0 24 24"
                                pathClassName={cx('panelIcon')}
                            >
                                <IconArrowLeftApollo />
                            </Icon>
                        </a>
                    )}
                    <span
                        data-automation-id="at-panel-title"
                        className={cx(
                            'panelHeaderText',
                            'absolute',
                            'pt-half',
                            'font-open-sans-semibold'
                        )}
                        tabIndex={-42}
                    >
                        {this.getCartAtcHeaderText()}
                    </span>
                </>
                <a
                    href=""
                    className={cx('closeIcon', 'absolute', 'inline-block')}
                    onClick={this.closePanel}
                    data-automation-id="at-primary-close-button"
                >
                    <Icon iconType="svg" width="18px" height="18px" viewBox="0 0 18 18">
                        <HambCloseApollo />
                    </Icon>
                </a>
            </div>
        );
    };

    patchNativeHeader(backButton = false) {
        this.props.isNative &&
            this.props.actions.patchHeader({
                backButton,
            });
    }

    renderPanelHeader = () => {
        const {
            panelTitleClass,
            panelHeaderRenderer,
            cartSuccess,
            cartAdditionalServices,
            panelIconComponent,
            requestUrl,
            isNative,
            fromKA,
        } = this.props;
        let { panelTitle, panelIcon, panelTitleAlignment, backButton } = this.props;
        let panelIconComp = panelIconComponent;
        if (cartAdditionalServices) {
            return this.cartATCPanelHeader();
        }
        if (this.state.showDetailSlider) {
            panelTitle = '';
            panelIcon = 'close';
            panelIconComp = <Close />;
            panelTitleAlignment = 'justified';
            backButton = true;
        }
        const chooseOption = cartSuccess ? 'Choose Options' : '';
        return panelHeaderRenderer ? (
            panelHeaderRenderer()
        ) : (
            <div
                className={cx(styles.panelHeader, `panel-title-${panelTitleAlignment}`, {
                    miniPDPPanel: cartSuccess,
                })}
            >
                {!(isNative && requestUrl === '/') && <div>{chooseOption}</div>}
                {backButton && (
                    <a
                        href=""
                        className={cx(styles.backButton, styles.backIcon)}
                        onClick={this.backPanel}
                        data-automation-id="at-slide-backTo-button"
                    >
                        <Icon
                            iconType="svg"
                            width="18px"
                            height="18px"
                            viewBox="0 0 48 48"
                            pathClassName={styles.panelIcon}
                        >
                            <IconArrowLeftBlack />
                        </Icon>
                        <span
                            data-automation-id="at-panel-title"
                            className={styles.panelTitle}
                            tabIndex={-42}
                        >
                            Back
                        </span>
                    </a>
                )}
                {fromKA ? (
                    <div className={cx(styles.backIcon)} data-automation-id="at-slide-back-button">
                        <span
                            data-automation-id="at-panel-title"
                            className={cx('panelTitleKA', panelTitleClass)}
                            tabIndex={-42}
                        >
                            {panelTitle}
                        </span>
                        <a className={cx(styles.buttonsBlock)} href="" onClick={this.closePanel}>
                            <Icon
                                iconType="svg"
                                width="18px"
                                height="18px"
                                viewBox="0 0 48 48"
                                pathClassName={cx(panelIcon, 'mr-1')}
                            >
                                {panelIcon === 'arrow-left' ? (
                                    <IconArrowLeftBlack />
                                ) : (
                                    panelIconComp
                                )}
                            </Icon>
                        </a>
                    </div>
                ) : (
                    <a
                        href=""
                        className={cx(styles.backIcon, { buttonsBlock: cartSuccess })}
                        onClick={this.closePanel}
                        data-automation-id="at-slide-back-button"
                    >
                        <Icon
                            iconType="svg"
                            width="18px"
                            height="18px"
                            viewBox="0 0 48 48"
                            pathClassName={styles.panelIcon}
                        >
                            {panelIcon === 'arrow-left' ? <IconArrowLeftBlack /> : panelIconComp}
                        </Icon>
                        <span
                            data-automation-id="at-panel-title"
                            className={cx('panelTitle', panelTitleClass)}
                            tabIndex={-42}
                        >
                            {panelTitle}
                        </span>
                    </a>
                )}
            </div>
        );
    };

    renderPanelHeaderIosWebView = () => {
        const { panelTitleAlignment } = this.props;
        return (
            <div className={cx(styles.panelHeader, `panel-title-${panelTitleAlignment}`)}>
                <a
                    href=""
                    className={cx('closeIcon', 'inline-block', 'ml-3')}
                    onClick={this.closePanel}
                    data-automation-id="at-primary-close-button"
                >
                    <Icon iconType="svg" width="18px" height="18px" viewBox="0 0 18 18">
                        <HambCloseApollo />
                    </Icon>
                    <span className="font-open-sans-regular ml-1 text-medium text-gray-600">
                        Close
                    </span>
                </a>
            </div>
        );
    };

    render() {
        const {
            theme,
            hideContentScroll,
            enableExpandedAtc,
            deviceType,
            panelContentTheme,
            isNative,
            requestUrl,
            enableFullViewPanel,
            mobileAppWebViewBuildConfig,
            fromKA,
        } = this.props;
        const contextValue = { showDetailSlider: this.showDetailSlider };
        const iosMinVersion = _get(mobileAppWebViewBuildConfig, 'bofHotFix1101.iosMinVersion', '');
        const canEnableFeature = iosMinVersion && enableFeatureInApp({ iosMinVersion });
        let isCheckoutIosApp = false;
        const showPaneHeader =
            !(isNative && requestUrl !== '/') || (isNative && requestUrl !== '/' && fromKA);
        /* istanbul ignore if */
        if (isNative && canEnableFeature && window.webkit) {
            const isCheckoutPresent = requestUrl.match(/\/checkout\//i);
            isCheckoutIosApp = isCheckoutPresent && isCheckoutPresent.length > 0;
        }
        return (
            <div
                className={cx(theme, {
                    'mobile-exp': deviceType && deviceType.isMobile,
                    'tablet-exp': deviceType && deviceType.isTablet,
                })}
            >
                <button className={this.getStyleToogleWrapper()} onClick={this.closePanel} />
                <div
                    data-automation-id="at-active-panel"
                    className={cx(
                        this.getStyleTooglePanel(),
                        enableExpandedAtc ? 'expandPanel' : '',
                        {
                            'animate-on-load': this.state.animateOnLoad,
                        },
                        enableFullViewPanel ? 'expandFullViewPanel' : ''
                    )}
                    onTransitionEnd={this.onTransitionEnd}
                    onAnimationEnd={this.onTransitionEnd}
                >
                    {showPaneHeader && this.renderPanelHeader()}
                    {isCheckoutIosApp && this.renderPanelHeaderIosWebView()}
                    {!this.state.closed ? (
                        <div
                            data-automation-id="at-panel-content"
                            id="atPanelContent"
                            className={cx([
                                hideContentScroll ? 'panelContentNoScroll' : 'panelContent',
                                panelContentTheme,
                            ])}
                        >
                            <SlidePanelContext.Provider value={contextValue}>
                                <div
                                    className={cx(
                                        'main-slider-content-animate-before',
                                        this.state.showDetailSlider
                                            ? 'main-slider-content-animate-after'
                                            : ''
                                    )}
                                >
                                    {this.props.children}
                                </div>
                                <div
                                    className={cx(
                                        'pl-3',
                                        'pr-3',
                                        'pt-1',
                                        'detail-slider-content-animate-before',
                                        this.state.showDetailSlider
                                            ? 'detail-slider-content-animate-after'
                                            : ''
                                    )}
                                >
                                    {this.state.detailSliderContent
                                        ? this.state.detailSliderContent
                                        : ''}
                                </div>
                            </SlidePanelContext.Provider>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        context: { isNative = false },
        context: { requestUrl = '' },
        isAddEditSlider,
        context: { preferences: { mobileAppWebViewBuildConfig = {} } = {} },
    } = state;
    return {
        isNative,
        requestUrl,
        isAddEditSlider,
        mobileAppWebViewBuildConfig,
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...nativeAppActions,
            ...ATCInterstitalActions,
        },
        dispatch
    ),
});

export default ScrollLockHOCFactory('isOpenPanel')(
    connect(mapStateToProps, mapDispatchToProps)(SlidePanel)
);
